const projects = [
    {
        title: "CoinFlipPostage",
        description: "Allows users to buy postage labels with cryptocurrency",
        imageSource: "./buybitcoinpostage.png",
        technologies: [
            "Javascript",
            "React",
            "Graphql",
            "Nodemailer",
            "Firebase",
            "Coinbase Commerce API",
            "Express",
            "Apollo"
        ],
        repository: "",
        liveLink:"https://www.coinflippostage.com/"
    },
    {
        title: "Class Manager",
        description: "A class utility tool for managing instructional and student content",
        imageSource: "./cm.PNG",
        technologies: [
            "Javascript",
            "Node",
            "Inquirer"
        ],
        repository: "https://github.com/merpig/classManager"
    },
    {
        title: "RubiksProgram",
        description: "A plug and play Rubik's Cube simulator that solves any rubik's cube from size 2x2 to 10x10",
        imageSource: "./solved.PNG",
        technologies: [
            "Javascript",
            "React",
            "THREE.js"
        ],
        repository: "https://github.com/merpig/RubiksProgram",
        liveLink:"https://merpig.github.io/RubiksProgram/"
    },
    {
        title: "MegaMinx",
        description: "A plug and play MegaMinx simulator and solver",
        imageSource: "./megaminx.png",
        technologies: [
            "Javascript",
            "React",
            "THREE.js"
        ],
        repository: "https://github.com/merpig/MegaMinx",
        liveLink:"https://merpig.github.io/MegaMinx/"
    }
]

export default projects;